module.exports = {
  aboutEg: {
    'zh-CN': '关于Enjoy Game',
    'zh-TW': '關於Enjoy Game',
    'en-US': 'About EnjoyGame',
    'th-TH': 'เกี่ยวกับ Enjoy Game',
    'vi-VN': 'About EnjoyGame'
  },
  aboutEgP1: {
    'zh-CN': '上海萌果信息科技有限公司（萌果游戏）成立于2012年，专注于互联网移动游戏的研发和发行。发展至今近130人，公司业务从手机游戏开始延伸至H5游戏、VR游戏、海外游戏代理发行等，旗下的EnjoyGame（英卓游戏）成立于2015年，专注致力于将中国精品手游发行到海外全球市场。团队40余人，核心成员均有8年以上海外发行经验，以专业的快速发展，以实力打造更优质精品，形成了独有的行业品牌和口碑。发行范围覆盖全球。公司致力于成为"最好的移动网络游戏制造、发行商"，将为全球的移动互联网用户提供一个更自由、更宽广、更娱乐的游戏世界！接下来萌果还将陆续推出更多不同主题、不同类型的移动互联网产品，给大家带来更优质的游戏体验！',
    'zh-TW': 'Enjoy Game 遊戲成立於2015年，核心成員均有八年以上行業經驗，公司致力於將中國精品手機遊戲發行到海外全球市場，以專業謀求更快速發展，以實力打造更優質精品，形成了獨有的行業品牌和口碑。',
    'en-US': 'Enjoy Game was established in 2015. The core members have more than 8 years of professional experience. The company is committed to distribute Chinese boutique mobile games to overseas markets. With several boutique products distributed, we already own a unique brand and reputation. And we are seeking for faster development with our professional ability!',
    'th-TH': 'ค่าย Enjoy Game ก่อตั้งขึ้นในปี 2015 พนักงานหลักต่างก็มีประสบการณ์มากกว่า 8 ปี เป็นบริษัทที่ให้บริการเกมส์มือถือทั่วโลก เราใส่ใจในคุณภาพของเกมส์เป็นที่สุด จึงกลายเป็นหนึ่งในบริษัทเกมส์ที่มีชื่อเสียง',
    'vi-VN': 'Enjoy Game was established in 2015. The core members have more than 8 years of professional experience. The company is committed to distribute Chinese boutique mobile games to overseas markets. With several boutique products distributed, we already own a unique brand and reputation. And we are seeking for faster development with our professional ability!'
  },
  aboutEgP2: {
    'zh-CN': '2015年到2016年上半年,Enjoy Game主攻港澳台、东南亚市场,2016年Q2开始开拓全球多语言市场, 均取得显著成功, 所发行的《天堂战记 Lineage War》《梦幻神域》等游戏,多次被谷歌苹果推荐,均 最高取得下载TOP1-3,畅销TOP1-5 的成绩。',
    'zh-TW': '2015年到2016年上半年，Enjoy Game主攻港澳台、東南亞市場，2016年Q2開始開拓全球多語言市場，均取得顯著成功，所發行的《Paradise War》《Sword of Fantasy》等遊戲，多次被谷歌蘋果推薦，均 最高取得下載TOP1-3，暢銷TOP1-5 的成績。',
    'en-US': 'From 2015 to the first six months of 2016, EnjoyGame aimed specially at the markets of Hong Kong, Macao and Southeast Asia. Now, we have begun to develop the global multi-lingual market and have achieved remarkable success. Our games "Paradise War" and "Sword of Fantasy" have been featured repeatedly by Google Play and App Store, with Top Download rank 1-3, and Top Grossing rank1-5.',
    'th-TH': 'From 2015 to the first six months of 2016, EnjoyGame aimed specially at the markets of Hong Kong, Macao and Southeast Asia. Now, we have begun to develop the global multi-lingual market and have achieved remarkable success. Our games "Paradise War" and "Sword of Fantasy" have been featured repeatedly by Google Play and App Store, with Top Download rank 1-3, and Top Grossing rank1-5.',
    'vi-VN': 'From 2015 to the first six months of 2016, EnjoyGame aimed specially at the markets of Hong Kong, Macao and Southeast Asia. Now, we have begun to develop the global multi-lingual market and have achieved remarkable success. Our games "Paradise War" and "Sword of Fantasy" have been featured repeatedly by Google Play and App Store, with Top Download rank 1-3, and Top Grossing rank1-5.'
  },
  brandAdvantage: {
    'zh-CN': '品牌优势',
    'zh-TW': '品牌優勢',
    'en-US': 'Our Advantages',
    'th-TH': 'Our Advantages',
    'vi-VN': 'Our Advantages'
  },
  operationTitle: {
    'zh-CN': '卓越的运营能力',
    'zh-TW': '卓越的運營能力',
    'en-US': 'Excellent operation capacity',
    'th-TH': 'Excellent operation capacity',
    'vi-VN': 'Excellent operation capacity'
  },
  operationItem1: {
    'zh-CN': '产品识别能力',
    'zh-TW': '產品識別能力',
    'en-US': 'Product identification capability',
    'th-TH': 'Product identification capability',
    'vi-VN': 'Product identification capability'
  },
  operationItem2: {
    'zh-CN': '产品调优能力',
    'zh-TW': '產品調優能力',
    'en-US': 'Product optimization capability',
    'th-TH': 'Product optimization capability',
    'vi-VN': 'Product optimization capability'
  },
  operationItem3: {
    'zh-CN': '持续运营能力',
    'zh-TW': '持續運營能力',
    'en-US': 'Continuous operation capacity',
    'th-TH': 'Continuous operation capacity',
    'vi-VN': 'Continuous operation capacity'
  },
  saleTitle: {
    'zh-CN': '领先的营销能力',
    'zh-TW': '領先的營銷能力',
    'en-US': 'Leading marketing capability',
    'th-TH': 'Leading marketing capability',
    'vi-VN': 'Leading marketing capability'
  },
  saleItem1: {
    'zh-CN': '全球采量能力',
    'zh-TW': '全球採量能力',
    'en-US': 'Attracting global players capacity',
    'th-TH': 'Attracting global players capacity',
    'vi-VN': 'Attracting global players capacity'
  },
  saleItem2: {
    'zh-CN': '持续优化能力',
    'zh-TW': '持續優化能力',
    'en-US': 'Continuous optimization capability',
    'th-TH': 'Continuous optimization capability',
    'vi-VN': 'Continuous optimization capability'
  },
  saleItem3: {
    'zh-CN': '全面包装能力',
    'zh-TW': '全面包裝能力',
    'en-US': 'Global package capacity',
    'th-TH': 'Global package capacity',
    'vi-VN': 'Global package capacity'
  },
  techTitle: {
    'zh-CN': '强大的技术支持',
    'zh-TW': '強大的技術支持',
    'en-US': 'Powerful technical support',
    'th-TH': 'Powerful technical support',
    'vi-VN': 'Powerful technical support'
  },
  techItem1: {
    'zh-CN': '快速的对接流程',
    'zh-TW': '快速的對接流程',
    'en-US': 'Fast docking process',
    'th-TH': 'Fast docking process',
    'vi-VN': 'Fast docking process'
  },
  techItem2: {
    'zh-CN': '强大的数据分析能力',
    'zh-TW': '強大的數據分析能力',
    'en-US': 'Powerful data analysis capability',
    'th-TH': 'Powerful data analysis capability',
    'vi-VN': 'Powerful data analysis capability'
  },
  techItem3: {
    'zh-CN': '高度定制化的数据采集能力',
    'zh-TW': '高度定制化的數據採集能力',
    'en-US': 'Highly customizable data acquisition capability',
    'th-TH': 'Highly customizable data acquisition capability',
    'vi-VN': 'Highly customizable data acquisition capability'
  },
  history: {
    'zh-CN': '发展历程',
    'zh-TW': '發展歷程',
    'en-US': 'Development',
    'th-TH': 'กระบวนการพัฒนา',
    'vi-VN': 'Development'
  },
  haveGoodGame: {
    'zh-CN': '有好的游戏产品？',
    'zh-TW': '有好的遊戲產品？',
    'en-US': 'Have good game products?',
    'th-TH': 'Have good game products?',
    'vi-VN': 'Have good game products?'
  },
  gotToSubmit: {
    'zh-CN': '前往提交',
    'zh-TW': '前往提交',
    'en-US': 'Go to submit',
    'th-TH': 'Go to submit',
    'vi-VN': 'Go to submit',
  }
};



// WEBPACK FOOTER //
// ./src/lang/about.js